module.exports = __webpack_public_path__ + "img/genespoir.79455b8f.jpg";